import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=4b41a202&scoped=true&"
import script from "./Medicine.vue?vue&type=script&lang=js&"
export * from "./Medicine.vue?vue&type=script&lang=js&"
import style0 from "./Medicine.vue?vue&type=style&index=0&id=4b41a202&lang=scss&scoped=true&"
import style1 from "./Medicine.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41a202",
  null
  
)

export default component.exports